const transliterationMap: Record<string, string> = {
  // Німецькі
  ä: "ae",
  ö: "oe",
  ü: "ue",
  ß: "ss",

  // Українські
  а: "a",
  б: "b",
  в: "v",
  г: "h",
  ґ: "g",
  д: "d",
  е: "e",
  є: "ye",
  ж: "zh",
  з: "z",
  и: "y",
  і: "i",
  ї: "yi",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ь: "",
  ю: "yu",
  я: "ya",

  // Польські
  ą: "a",
  ć: "c",
  ę: "e",
  ł: "l",
  ń: "n",
  ó: "o",
  ś: "s",
  ź: "z",
  ż: "z",

  // Чеські
  á: "a",
  č: "c",
  ď: "d",
  é: "e",
  ě: "e",
  í: "i",
  ň: "n",
  ř: "r",
  š: "s",
  ť: "t",
  ú: "u",
  ů: "u",
  ý: "y",
  ž: "z",

  // Російські
  ы: "y",
  э: "e",
  ъ: "",

  // Французькі та інші західноєвропейські
  à: "a",
  â: "a",
  æ: "ae",
  ç: "c",
  è: "e",
  ê: "e",
  ë: "e",
  î: "i",
  ï: "i",
  ô: "o",
  œ: "oe",
  ù: "u",
  û: "u",
  ÿ: "y",

  // Скандинавські
  å: "a",
  ø: "o",

  // Балтійські (латвійська, литовська)
  ā: "a",
  ē: "e",
  ģ: "g",
  ī: "i",
  ķ: "k",
  ļ: "l",
  ņ: "n",
  ū: "u",
};

/**
 * Форматує назву для URL (slug)
 * Підтримує транслітерацію німецької, української, польської, чеської та інших мов
 *
 * Порядок обробки:
 * 1. Trim пробілів
 * 2. toLowerCase (щоб не дублювати uppercase в мапі)
 * 3. Транслітерація символів
 * 4. Заміна слешів і дефісів
 * 5. Заміна пробілів на дефіси
 * 6. Видалення недопустимих символів
 * 7. Очищення повторюваних дефісів
 *
 * @param name - Назва для форматування
 * @returns Відформатована назва для URL
 *
 * @example
 * formatName("Mechatronik für VW") // "mechatronik-fuer-vw"
 * formatName("Ремонт коробки передач") // "remont-korobky-peredach"
 * formatName("Naprawa skrzyni biegów") // "naprawa-skrzyni-biegow"
 * formatName("Oprava převodovky") // "oprava-prevodovky"
 * formatName("Reparatursatz für Automatikgetriebe Ford 8F57 — OEM: J1KZ-7153-C")
 * // "reparatursatz-fuer-automatikgetriebe-ford-8f57-oem-j1kz-7153-c"
 */
export const formatName = (name: string): string => {
  return (
    name
      .trim()
      // Спочатку toLowerCase (щоб не дублювати великі літери в мапі)
      .toLowerCase()
      // Транслітерація
      .split("")
      .map((char) => transliterationMap[char] || char)
      .join("")
      // Заміна слешів на дефіси
      .replace(/[\/]/g, "-")
      // Заміна різних типів дефісів на стандартний
      .replace(/[–—]/g, "-")
      // Заміна пробілів на дефіси
      .replace(/\s+/g, "-")
      // Видалення всіх символів крім латиниці, цифр і дефісів
      .replace(/[^a-z0-9-]/g, "")
      // Видалення повторюваних дефісів
      .replace(/-+/g, "-")
      // Видалення дефісів на початку і в кінці
      .replace(/^-+|-+$/g, "")
  );
};
